import { useEffect, useState } from 'react'
import Message from '../Message/Message'
import getintouch from '../../../assets/images/contactus/getintouch.webp'

const GetInTouchSection = () => {
  const [isUltraWide, setIsUltraWide] = useState(false)

  useEffect(() => {
    const checkWidth = () => {
      setIsUltraWide(window.innerWidth >= 1900)
    }

    checkWidth()
    window.addEventListener('resize', checkWidth)

    return () => window.removeEventListener('resize', checkWidth)
  }, [])

  return (
    <section
      className={`mx-auto py-14 md:py-18 ${
        isUltraWide ? 'w-[60%]' : 'w-[90%] 2xl:w-[75%]'
      }`}
    >
      <div className="grid grid-cols-1 items-stretch 2xl:gap-8 lg:grid-cols-[1fr_1fr] md:min-h-[650px] lg:min-h-[680px] xl:min-h-[700px]">

        {/* MESSAGE */}
        <Message
          variant="contact"
          wrapperClassName="h-full justify-center items-center text-center 2xl:my-5"
        />

        <div className="hidden lg:flex h-full items-center justify-center overflow-hidden rounded-3xl p-3 sm:p-4 md:p-5 2xl:w-full">
          <img
            src={getintouch}
            alt="Get in touch"
            className="h-full w-full object-contain"
          />
        </div>

      </div>
    </section>
  )
}

export default GetInTouchSection